// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@container fashionTile (max-width: 414px){.frisbuy-outfit-on-model .frisbuy-outfit-on-model__kit .products-scoll-block .frisbuy-outfit-on-model__kit-products .frisbuy-outfit-product-item .frisbuy-outfit-product-item__image .frisbuy-like-button{inset:7px auto auto 8px;width:21px}}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
